import { SecuredPaymentClient } from 'Core/Api/Payment/SecuredPaymentClient';
import TokenUtility from 'Core/TokenUtility';
import ConfigUtility from 'Core/ConfigUtility';

export class TransactionsHistoryHandler {
  props: any;
  constructor(props) {
    this.props = props;
  }

  async GetTransactionsHistory(id: string) {
    const client = new SecuredPaymentClient();
    client.showLoading = true;
    client.DisableToken = true;
    var config = await ConfigUtility.get();
    var authorization = TokenUtility.GetUMAToken();

    return client.getBillOfLadingPayments(id, 1000, 1, 'Bearer ' + authorization);
  }
}
